export const isMac = () => {
    return window.navigator.platform.toUpperCase().indexOf('MAC') >= 0;
}